import { type MapSettingsDataAction } from '../../data/mapSettingsData.action';
import { type ExportReportToolStateAction } from './exportReportToolState.action';
import {
  exportReportDisable, exportReportEnable,
} from './exportReportToolState.actionCreators';
import { type ExportReportToolState } from './exportReportToolState.state';

export const mapSettingsExportReportInitialState: ExportReportToolState = {
  isActive: false,
  params: null,
};

export const exportReportToolStateReducer = (
  state = mapSettingsExportReportInitialState,
  action: ExportReportToolStateAction | MapSettingsDataAction
): ExportReportToolState => {
  if (exportReportEnable.match(action)) {
    return {
      isActive: true,
      params: action.payload.params,
    };
  }

  if (exportReportDisable.match(action)) {
    return {
      isActive: false,
      params: null,
    };
  }

  return state;
};
